import { Component, Input } from '@angular/core';

export interface SubNavItem {
  label: string;
  route: string;
}

@Component({
  selector: 'bwc-sub-navigation',
  templateUrl: './sub-navigation.component.html',
  styleUrls: ['./sub-navigation.component.scss'],
})
export class SubNavigationComponent {
  @Input() items: SubNavItem[] = [];
}
